// src/components/CTA.jsx
import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';

const CTA = () => {
  const { siteContent } = useSiteContent();
  const ctaCms = siteContent?.cta || {};

  return (
    <section className="w-full py-8 md:py-20 bg-transparent relative z-10 overflow-hidden border-none select-none">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* 🌌 Call-To-Action Box with Signature Gold Gradient & Glow Border */}
        <div className="relative w-full rounded-[2rem] sm:rounded-[3rem] p-6 sm:p-16 bg-gradient-to-r from-[#F2B135]/15 via-black/90 to-[#F2B135]/10 border-2 border-[#F2B135]/50 backdrop-blur-xl text-center overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.9),0_0_40px_rgba(242,177,53,0.15)]">
          
          {/* ✨ Ambient Inner Neon Glow Elements */}
          <div className="absolute -top-24 -left-24 w-72 h-72 bg-[#F2B135]/15 rounded-full blur-[100px] pointer-events-none" />
          <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-[#F2B135]/10 rounded-full blur-[120px] pointer-events-none" />

          {/* Decorative Corner Grid Vector Lines */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[linear-gradient(to_right,#808080_1px,transparent_1px),linear-gradient(to_bottom,#808080_1px,transparent_1px)] bg-[size:24px_24px]" />

          {/* Content Wrapper */}
          <div className="relative z-10 max-w-3xl mx-auto space-y-6 sm:space-y-8">
            
            {/* Small Glowing Upper Tag */}
            <div className="inline-flex items-center gap-2 bg-[#F2B135]/10 border border-[#F2B135]/30 px-4 py-1.5 rounded-full">
              <span className="w-2 h-2 rounded-full bg-[#F2B135] animate-ping" />
              <span className="text-xs font-black text-[#F2B135] uppercase tracking-[0.2em] font-display">
                {ctaCms.badge || "Let's Make Magic Happen"}
              </span>
            </div>

            {/* Main Action Text */}
            <h2 className="text-3xl sm:text-6xl font-black text-white tracking-tight leading-[1.15] font-display" style={{ fontFamily: 'Outfit, sans-serif' }}>
              {ctaCms.titleLine1 || "Have a Great Idea?"} <br />
              {ctaCms.titleLine2 || "Let's Build It"}{" "}
              <span className="text-[#F2B135] drop-shadow-[0_0_15px_rgba(242,177,53,0.3)]">
                {ctaCms.titleLine3 || "Into Reality."}
              </span>
            </h2>

            {/* Supporting Copy */}
            <p className="text-sm sm:text-lg text-white/80 font-medium max-w-xl mx-auto leading-relaxed">
              {ctaCms.subtitle || "Stop waiting for the perfect time. Drop us a message today, schedule a strategy deployment call, and turn your technical vision into high-yield code."}
            </p>

            {/* Interactive Dual Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              
              {/* Primary High-Glow CTA Button */}
              <button 
                onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}
                className="btn-animated-gold px-10 py-4 text-base sm:text-lg"
              >
                {ctaCms.primaryBtnText || "Get Started Now"}
              </button>

              {/* Secondary Clean Border Button */}
              <a
                href="mailto:info@rojrztech.com"
                className="inline-flex items-center justify-center gap-2 px-10 py-4 rounded-full border-2 border-white/25 text-white font-black text-base sm:text-lg hover:border-[#F2B135] hover:text-[#F2B135] hover:bg-[#F2B135]/10 transition-all duration-300 hover:scale-105"
              >
                Direct Mail
              </a>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default CTA;